import { useState } from 'preact/hooks';
import { setTechName } from '../state/session';

/** First-run identity: the tech's name stamps their completions (set once; v1 rule). */
export function NameGate() {
  const [name, setName] = useState('');

  return (
    <div class="flex min-h-dvh flex-col items-center justify-center bg-band px-6">
      <div class="w-full max-w-xs rounded-2xl bg-white p-6 shadow-2xl">
        <div class="mb-1 text-xl font-extrabold text-navy-900">Who's this phone?</div>
        <p class="mb-4 text-sm text-slate-500">Your name goes on the jobs you close out.</p>
        <form
          onSubmit={(e) => {
            e.preventDefault();
            setTechName(name);
          }}
        >
          <label class="mb-1 block text-sm font-semibold text-navy-900" for="techName">
            First name
          </label>
          <input
            id="techName"
            class="tap w-full rounded-xl border border-slate-300 px-4 py-3 text-lg focus:border-brand-600"
            type="text"
            autocomplete="given-name"
            maxLength={60}
            value={name}
            onInput={(e) => setName((e.target as HTMLInputElement).value)}
          />
          <button class="btn-primary mt-4 w-full" type="submit" disabled={!name.trim()}>
            Start
          </button>
        </form>
      </div>
    </div>
  );
}
